<div class="premiumMinimumContainer">
  @if (model?.premiumMinimum && model?.showPremiumMinimum) {
    <table id="premiumTable">
      <thead>
        <tr>
          @if (!isMobileMode()) {
            <th class="emptyColumn"></th>
          }
          @if (hasMemberCredit()) {
            <th class="creditColumn">{{'subscription.form.premium.table.creditHeader' | translate}}</th>
          }
          <th class="premiumColumn">{{'subscription.form.premium.table.primeHeader' | translate}}</th>
          @if (hasMemberSuprime()) {
            <th class="surpremimumColumn">{{'subscription.form.premium.table.surpremimumHeader' | translate}}</th>
          }
          <th class="tpaColumn">{{'subscription.form.premium.table.tpaHeader' | translate}}</th>
          <th class="totalColumn">{{'subscription.form.premium.table.totalHeader' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        @if (isMobileMode()) {
          <tr>
            <td class="emptyColumn" colspan="100%">
              <div class="mandatoryBaseAssuranceText">
                {{'subscription.form.premium.table.mandatoryBaseAssurance' | translate}}
              </div>
              <div class="mandatoryBaseAssuranceValue">
                {{ model.premiumMinimum.premiumAmount | currencyCustom:0 }}
              </div>
            </td>
          </tr>
        }
        <tr>
          @if (!isMobileMode()) {
            <td class="emptyColumn">
              <div class="mandatoryBaseAssuranceText">
                {{'subscription.form.premium.table.mandatoryBaseAssurance' | translate}}
              </div>
              <div class="mandatoryBaseAssuranceValue">
                {{ model.premiumMinimum.premiumAmount | currencyCustom:0  }} par sinistre / {{ model.premiumMinimum.periodLimitAmount | currencyCustom:0  }} par période
              </div>
            </td>
          }
          @if (hasMemberCredit()) {
            <td class="creditColumn valueColumn">
              {{ model.premiumMinimum.calcCredit  | currencyCustom}}
            </td>
          }
          <td class="premiumColumn valueColumn">
            {{ model.premiumMinimum.calcPremiumBase | currencyCustom}}
          </td>
          @if (hasMemberSuprime()) {
            <td class="surpremimumColumn valueColumn">
              {{ model.premiumMinimum.calcSubprime | currencyCustom}}
            </td>
          }
          <td class="tpaColumn valueColumn">
            {{ model.premiumMinimum.calcTPA | currencyCustom}}
          </td>
          <td class="totalColumn valueColumn">
            {{ model.premiumMinimum.calcTotal | currencyCustom}}
          </td>
        </tr>
      </tbody>
    </table>
  }

</div>
